export const URL_HOME = "/";
/*export const URL_SERVICES = "/services";*/
export const URL_PLOMBERIE = "/plomberie";
export const URL_CHAUFFAGE = "/chauffage";
export const URL_CLIMATISATION = "/climatisation";
export const URL_RENOVATION = "/renovation";
export const URL_AIDES = "/aides";
export const URL_CONTACT = "/contact";